import { render, staticRenderFns } from "./FaqsCard.vue?vue&type=template&id=793ca676&"
import script from "./FaqsCard.vue?vue&type=script&lang=js&"
export * from "./FaqsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports